import { createContext, useContext } from 'react';

// Auth / subscription state owned by App.js and shared with every page and popup.
export const SessionContext = createContext(null);

export const useSession = () => useContext(SessionContext);
